import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/assets/images/settings/thank_you_heart.svg")